import { ImageSourceService } from './image-source.service';

export default angular
  .module('sfMobile.services.image-source', ['sfMobile.services.pov'])
  .service('imageSourceService', ImageSourceService).name;
